export const sum = (values) => values.reduce((total, next) => total + next, 0);

export const roundToOneDecimal = (value) => Number(Math.floor(value * 10) / 10);

export const isPowerOf2 = (value) => !!(isNaN(value) ? false : value && (value & (value - 1)) === 0);

export const areIntervalsOverlapping = ([a, b]: [number, number], [c, d]: [number, number]) => {
  return (c > a && c < b) || (d > a && d < b) || (c < a && d > b) || (a === c && b === d);
};
